import { createClient } from "@supabase/supabase-js";
import { Database } from "src/supabase.types";

export const supabaseClient = createClient<Database>(
  import.meta.env.VITE_SUPABASE_API_URL || "",
  import.meta.env.VITE_SUPABASE_ANON_KEY || ""
);

// Function to get the latest Supabase session
export const getSupabaseSession = async () => {
  const { data } = await supabaseClient.auth.getSession();

  return data?.session ?? null;
};
